import {baseRequest} from './base'

/**
 * @desc 新增人员
 */
function addPerson(params){
  //清除空白字段
  params = utils.common.checkNull(params);
  return baseRequest('/api/pcWeb/accUser/create','post',params);
}

/**
 * @desc 人员列表
 */
function getPersonList(params){
  //清除空白字段
  params = utils.common.checkNull(params);
  let tempUrl = '/api/pcWeb/accUser/'
  return baseRequest(tempUrl,'get',params);
}

/**
 * @desc 根据人员ID获取人员信息
 */
function getPersonById(id){
  return baseRequest(`/api/pcWeb/accUser/${id}`,'get');
}


/**
 * @desc 删除人员
 */
function deletePerson(id){
  return baseRequest(`/api/pcWeb/accUser/delete/${id}`,'get');
}

/**
 * @desc 修改人员
 */
function updatePerson(id,params){
  params = utils.common.checkNull(params);
  return baseRequest(`/api/pcWeb/accUser/update/${id}`,'post',params);
}


/**
 * @desc 禁用人员
 */
function disablePerson(id){
  return baseRequest(`/api/pcWeb/accUser/disable/${id}`,'get');
}

/**
 * @desc 解禁人员
 */
function enablePerson(id){
  return baseRequest(`/api/pcWeb/accUser/enable/${id}`,'get');
}

/**
 * @desc 查询负责人
 */
function getListManager(params){
  let tempUrl = '/api/pcWeb/accUser/listManager'
  return baseRequest(tempUrl,'get',params);
}

/**
 * @desc 重置密码
 */
function resetPassword(params){
  return baseRequest('/api/pcWeb/accUser/resetPassword','post',params);
}


export default {
  addPerson: addPerson,
  getPersonList: getPersonList,
  deletePerson: deletePerson,
  disablePerson: disablePerson,
  enablePerson: enablePerson,
  updatePerson: updatePerson,
  getPersonById: getPersonById,
  getListManager: getListManager,
  resetPassword: resetPassword,
}
